module.exports = __webpack_public_path__ + "app/assets/images/panic-icon-small.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/panic-icon-small.png
// module id = 876
// module chunks = 7